import Vue from 'vue';
// eslint-disable-next-line
export const staffsEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/staffs/staffsEventBus.js